import { useMutation } from '@tanstack/react-query';
import { requestOtp, resendOtp, resetPassword } from '../../api/apiOtp';

/**
 * Hook for managing the password reset flow
 * Handles requesting OTP, resending OTP, and the final password update
 */
export const usePasswordReset = () => {
    // 1. Request OTP (Start flow)
    const request = useMutation({
        mutationFn: ({ channel, identifier }) => {
            return requestOtp(channel, identifier, 'reset_password');
        }
    });

    // 2. Resend OTP
    const resend = useMutation({
        mutationFn: ({ channel, identifier }) => {
            return resendOtp(channel, identifier, 'reset_password');
        }
    });

    // 3. Reset Password (Final step)
    const reset = useMutation({
        mutationFn: (resetData) => {
            return resetPassword(resetData);
        }
    });

    return {
        request,
        resend,
        reset,
        isPending: request.isPending || resend.isPending || reset.isPending,
        error: request.error || resend.error || reset.error
    };
};
